import { OneDataCollection, useDataCollectionSource } from '@factorialco/f0-react/dist/experimental'
import { JobCatalogEnumsJobCatalogTreeNodeTypesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { Hierarchy, TreeNode } from 'modules/cost_centers/components/CostCentersStructure/types'

export const PreviewCostCenters = ({
  treeArray,
  jobStructure,
}: {
  treeArray: TreeNode[]
  jobStructure: JobCatalogEnumsJobCatalogTreeNodeTypesEnum
}) => {
  const families = treeArray[0]?.children || []

  const source = useDataCollectionSource<TreeNode>({
    dataAdapter: {
      fetchData: () => {
        return {
          pagesCount: 1,
          currentPage: 1,
          records: families,
          type: 'pages' as const,
          total: families.length,
          perPage: families.length,
        }
      },
    },
    itemsWithChildren: (treeNode: TreeNode) => {
      return (
        Hierarchy.includes(treeNode.type) &&
        Hierarchy.indexOf(treeNode.type) < Hierarchy.indexOf(jobStructure)
      )
    },
    fetchChildren: ({ item: treeNode }: { item: TreeNode }) => {
      return Promise.resolve({
        pagesCount: 1,
        currentPage: 1,
        records: treeNode.children,
        total: treeNode.children.length,
        perPage: treeNode.children.length,
      })
    },
    totalItemSummary: (totalItems) =>
      i18n.tp('finance.cost_centers_structure.preview.table.count', { count: totalItems }),
  })

  return (
    <OneDataCollection
      fullHeight
      source={source}
      visualizations={[
        {
          type: 'table',
          options: {
            columns: [
              {
                id: 'name',
                label: i18n.t('finance.cost_centers_structure.preview.table.name'),
                render: (treeNode: TreeNode) => ({
                  type: 'text',
                  value: treeNode.name,
                }),
              },
              {
                id: 'code',
                label: i18n.t('finance.cost_centers_structure.preview.table.code'),
                render: (treeNode) => {
                  if (treeNode.type === jobStructure) {
                    return {
                      type: 'text',
                      value: '-',
                    }
                  }

                  return {
                    type: 'text',
                    value: {
                      placeholder: i18n.t(
                        'finance.cost_centers_list.headers.job_catalog.not_applicable'
                      ),
                    },
                  }
                },
              },
              {
                id: 'legal_entity',
                label: i18n.t('finance.cost_centers_structure.preview.table.legal_entity'),
                render: (treeNode) => {
                  if (treeNode.type === jobStructure) {
                    return {
                      type: 'text',
                      value: i18n.t(
                        'finance.cost_centers_structure.preview.table.all_legal_entities'
                      ),
                    }
                  }

                  return {
                    type: 'text',
                    value: {
                      placeholder: i18n.t(
                        'finance.cost_centers_list.headers.job_catalog.not_applicable'
                      ),
                    },
                  }
                },
              },
              {
                id: 'status',
                label: i18n.t('finance.cost_centers_structure.preview.table.status'),
                render: (treeNode) => {
                  if (treeNode.type === jobStructure) {
                    return {
                      type: 'status',
                      value: {
                        status: 'positive',
                        label: i18n.t('finance.cost_centers_structure.preview.table.active'),
                      },
                    }
                  }

                  return {
                    type: 'text',
                    value: {
                      placeholder: i18n.t(
                        'finance.cost_centers_list.headers.job_catalog.not_applicable'
                      ),
                    },
                  }
                },
              },
            ],
          },
        },
      ]}
    />
  )
}
